import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    // Beware changing the active iconfont!
    // Only mdiSvg and md are supported by vuetify.
    // Other icons will need to be added manually.
    iconfont: 'md', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },
  theme: {
    themes: {
      light: {
        primary: colors.red.darken4, // #E53935
        secondary: colors.purple.base, // #FFCDD2
        accent: colors.deepOrange.darken2, // #3F51B5
      },
    },
  },
});
